import Button from "@/common/components/Button";
import useUserPermissions from "@/common/hooks/useUserPermissions";
import { useAdvanceMaintenanceDirectiveDiagnosticEntry } from "@/features/maintenance/features/workflows/features/diagnosticEntry/hooks/useAdvanceMaintenanceDirectiveDiagnosticEntry";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate, useParams } from "react-router-dom";

const DirectiveEntryDiagnosticEntryAwaitingManualStart = () => {
  const { id: workflowId } = useParams();

  const { forwarding } = useForwardingTabContext<
    MaintenanceForwardingsDirectiveEntryKlass.DiagnosticEntry
  >();

  const navigate = useNavigate();

  const queryClient = useQueryClient();

  const { hasUserPermission } = useUserPermissions();

  const {
    mutate: advanceDiagnosticEntry,
    isPending: advanceDiagnosticEntryIsPending,
  } = useAdvanceMaintenanceDirectiveDiagnosticEntry({
    directiveEntryId: forwarding.directive_entry.id,
    options: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['maintenanceForwarding', forwarding.id] });

        if (hasUserPermission('Establishment::Maintenance::Directive::DiagnosticEntries::Update')) {
          navigate(`/maintenance-workflows/${workflowId}/diagnostic-entry/${forwarding.id}`)
        }
      },
    }
  });

  return (
    <Button
      onClick={() => advanceDiagnosticEntry()}
      isLoading={advanceDiagnosticEntryIsPending}
      operationKlassToCheckPermission="Establishment::Maintenance::Directive::DiagnosticEntries::Advance"
    >
      Iniciar Diagnóstico e Orçamento
    </Button>
  );
}

export default DirectiveEntryDiagnosticEntryAwaitingManualStart;
